import { render, staticRenderFns } from "./index.vue?vue&type=template&id=069e4efe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=069e4efe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e4efe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Carousell: require('/opt/buildhome/repo/components/home/Carousell.vue').default,Partners: require('/opt/buildhome/repo/components/home/Partners.vue').default})
